<div class="modal-overlay" *ngIf="show" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">Nueva contraseña</h2>
      <button type="button" class="close-btn" (click)="onClose()">
        <lucide-icon class="custom-icon" name="X"></lucide-icon>
      </button>
    </div>

    <p class="modal-description">
      Por favor introduce tu email para que podamos enviarte un enlace para restablecer tu contraseña.
    </p>

    <form [formGroup]="forgotForm" (ngSubmit)="onSubmit()">
      <div class="form-field">
        <app-input
          [placeholder]="'Email'"
          [icon]="'envelope'"
          [size]="'large'"
          formControlName="email"
          [error]="!!forgotForm.get('email')?.invalid && !!forgotForm.get('email')?.touched"
          [errorMessage]="getErrorMessage('email')"
        ></app-input>
      </div>

      <app-button
        [label]="'Enviar'"
        (click)="onSubmit()"
        class="full-width-button"
      ></app-button>
    </form>

    <app-button
      [label]="'Volver al login'"
      (onClick)="onClose()"
      variant="link"
      size="large"
      class="bottom-link"
    />
  </div>
</div>